<app-truck-sidebar></app-truck-sidebar>
<div class="truck-owner-details">
  <div [class.spinner]="loading"></div>

  <div class="row to_container" *ngIf="!reportsArray?.length && !loading">
    <h4 class="error_msg">No Records Found.</h4>
  </div>
  <form [formGroup]="reportsForm" *ngIf="reportsArray?.length">
    <div class="filter_container">
      <button class="download_btn" (click)="downloadXl(downloadArray)">
        <img src="assets/img/download.svg" alt="" />Download
      </button>
      <p>Report</p>
      <button class="save_btn" *ngIf="searchOpen" (click)="openSearch_btn()">
        <img src="assets/img/search-white.svg" alt="" />
      </button>
      <div *ngIf="searchData" class="search_button">
        <input
          class="search pl-2"
          placeholder="Search Trip Id"
          formControlName="trip_id"
          id="driverNumber"
          #newItem
          (input)="transformToUppercase($event)"
        />
        <img
          *ngIf="isSearching"
          class="search_icon"
          (click)="searchBtn(newItem.value)"
          src="../../../assets/img/search-white.svg"
        />
        <span
          class="material-icons search_icon"
          *ngIf="clear_search"
          (click)="clearSearch()"
        >
          close
        </span>
      </div>
    </div>
    <div *ngIf="searchData" class="ledger_form">
      <div class="row">
        <div class="col-md-2">
          <mat-form-field
            class="flex-gt-sm example-full-width truck-type-input"
          >
            <mat-datepicker-toggle matPrefix [for]="picker1">
            </mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
            <input
              matInput
              [matDatepicker]="picker1"
              placeholder="From"
              formControlName="from_date"
              (click)="picker1.open()"
            />
          </mat-form-field>
        </div>
        <div class="col-md-2">
          <mat-form-field
            class="flex-gt-sm example-full-width truck-type-input"
          >
            <mat-datepicker-toggle matPrefix [for]="picker2">
            </mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
            <input
              matInput
              [matDatepicker]="picker2"
              placeholder="To"
              formControlName="to_date"
              (click)="picker2.open()"
            />
          </mat-form-field>
        </div>
        <div class="col-md-2">
          <mat-form-field class="example-field">
            <mat-select placeholder="From Location" formControlName="from_loc">
              <mat-option
                *ngFor="let fromloc of fromCityDetails"
                value="{{ fromloc }}"
                >{{ fromloc }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-2">
          <mat-form-field class="example-field">
            <mat-select placeholder="To Location" formControlName="to_loc">
              <mat-option
                *ngFor="let toloc of toCityDetails"
                value="{{ toloc }}"
                >{{ toloc }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-2">
          <mat-form-field class="example-field">
            <mat-select placeholder="Trip ID" formControlName="trip_id">
              <mat-option
                *ngFor="let tripiD of tripDetails"
                value="{{ tripiD }}"
                >{{ tripiD }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-2">
          <mat-form-field class="example-field">
            <mat-select placeholder="LR No" formControlName="lr_no">
              <mat-option *ngFor="let lr of lrDetails" value="{{ lr }}">{{
                lr
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <mat-form-field class="example-field">
            <mat-select placeholder="Vehicle No" formControlName="vehicle_no">
              <mat-option
                *ngFor="let vechicleNumber of vehicleDetails"
                value="{{ vechicleNumber }}"
                >{{ vechicleNumber }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field class="example-field">
            <mat-select
              placeholder="Sales Order No"
              formControlName="sales_order"
            >
              <mat-option
                *ngFor="let sales of salesorderDetails"
                value="{{ sales }}"
                >{{ sales }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field class="example-field">
            <mat-select
              placeholder="Work Order No"
              formControlName="work_order"
            >
              <mat-option
                *ngFor="let workOrder of workOrderDetails"
                value="{{ workOrder }}"
                >{{ workOrder }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field class="example-field">
            <mat-select placeholder="Trip Status" formControlName="trip_status">
              <mat-option
                *ngFor="let tripStatus of tripStatusDetails"
                value="{{ tripStatus }}"
                >{{ tripStatus }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="filter_btn_grp">
          <button class="reset_btn" (click)="reset()">Reset</button>
          <button class="filter_btn" (click)="applyFilter()">Apply</button>
        </div>
      </div>
    </div>
    <section
      class="example-container mat-elevation-z8"
      tabindex="0"
      style="text-align: center"
    >
      <table mat-table [dataSource]="reportList">
        <ng-container matColumnDef="Date">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let element">
            {{ element.pickup_date | date : "dd-MM-yyyy" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="WONo">
          <th mat-header-cell *matHeaderCellDef>WO No</th>
          <td mat-cell *matCellDef="let element">
            {{ element.workorder_info[0]?.workorder_id }}
          </td>
        </ng-container>
        <ng-container matColumnDef="TripId">
          <th mat-header-cell *matHeaderCellDef>Trip Id</th>
          <td mat-cell *matCellDef="let element">
            {{ element.trip_id }}
          </td>
        </ng-container>
        <ng-container matColumnDef="LRNo">
          <th mat-header-cell *matHeaderCellDef>LR No</th>
          <td mat-cell *matCellDef="let element">
            {{ element.workOrderOtherDetails?.lr_number || 0 }}
          </td>
        </ng-container>
        <ng-container matColumnDef="From">
          <th mat-header-cell *matHeaderCellDef>From</th>
          <td mat-cell *matCellDef="let element">
            {{ element.pickup_details?.from_city_name }}
          </td>
        </ng-container>
        <ng-container matColumnDef="To">
          <th mat-header-cell *matHeaderCellDef>To</th>
          <td mat-cell *matCellDef="let element">
            {{ element.dropoff_details?.to_city_name }}
          </td>
        </ng-container>
        <ng-container matColumnDef="TruckNo">
          <th mat-header-cell *matHeaderCellDef>Truck No</th>
          <td mat-cell *matCellDef="let element">
            {{ element.truck_info[0]?.truck_number }}
          </td>
        </ng-container>

        <ng-container matColumnDef="DDCNo">
          <th mat-header-cell *matHeaderCellDef>DDC No</th>
          <td mat-cell *matCellDef="let element">
            {{ element.workOrderOtherDetails?.ddc_no || 0 }}
          </td>
        </ng-container>
        <ng-container matColumnDef="LoadedQuantity">
          <th mat-header-cell *matHeaderCellDef>Loaded Quantity</th>
          <td mat-cell *matCellDef="let element">
            {{ element.workOrderOtherDetails?.loading_point || 0 }}
          </td>
        </ng-container>
        <ng-container matColumnDef="priceTon">
          <th mat-header-cell *matHeaderCellDef>Price/Ton</th>
          <td mat-cell *matCellDef="let element">
            ₹ {{ element.workOrderOtherDetails?.price_per_ton || 0 }}
          </td>
        </ng-container>
        <ng-container matColumnDef="unloadedQuantity">
          <th mat-header-cell *matHeaderCellDef>Unloaded Quantity</th>
          <td mat-cell *matCellDef="let element">
            {{ element.workOrderOtherDetails?.unloading_point || 0 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Amount">
          <th mat-header-cell *matHeaderCellDef>Total Amount</th>
          <td mat-cell *matCellDef="let element">
            <!-- {{
              element.workOrderOtherDetails?.loading_point *
                element.workOrderOtherDetails?.price_per_ton ||
                element.workOrderOtherDetails?.unloading_point *
                  element.workOrderOtherDetails?.price_per_ton
            }} -->
            {{
              (element.workorder_info[0]?.pay_as_load_quantity ===
              "loaded_quantity"
                ? element.workOrderOtherDetails?.loading_point
                  ? element.workOrderOtherDetails?.price_per_ton *
                  element.workOrderOtherDetails?.loading_point
                  : 0
                : element.workOrderOtherDetails?.unloading_point
                ? element.workOrderOtherDetails?.price_per_ton *
                element.workOrderOtherDetails?.unloading_point
                : 0
              ) | number : "1.2-2"
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="SalesOrderNo">
          <th mat-header-cell *matHeaderCellDef>Sales Order No</th>
          <td mat-cell *matCellDef="let element">
            {{ element.workOrderOtherDetails?.sales_order_number || 0 }}
          </td>
        </ng-container>
        <ng-container matColumnDef="Tripstatus">
          <th mat-header-cell *matHeaderCellDef>Trip Status</th>
          <td mat-cell *matCellDef="let element" class="capitalize">
            {{ capitalizeFirstLetter(element.trip_status) }}
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </section>
  </form>
</div>
